import vSelect from "vue-select";
import "@/assets/scss/vue/libs/vue-select.scss";
// import "vue-select/dist/vue-select.css";

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default {
  install(app,options){

    const deselectComp = h(FontAwesomeIcon, {
      size: "lg",
      icon: "fas fa-xmark",
    });

    const openIndicatorComp = h (FontAwesomeIcon,{
      size:'lg',
      icon:['fa', 'fa-angle-down'],
      class:['open-indicator']
    })

    vSelect.props.components.default = () => ({
      Deselect: deselectComp,
      OpenIndicator: openIndicatorComp
    });

    app.component('v-select',vSelect);
  }
};